import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { FAQLanguageList } from './FAQLanguageList';
import { FAQTopicList } from './FAQTopicList';
import { msgs } from './messages';
import * as S from './styles';

export { FAQItem } from './FAQItem';
export const FAQListTitle = S.Title;

type FAQListComponent = FC<
  (
    | {
        type: 'course';
        skipCoreLoop?: boolean;
        topicIconUrl?: undefined;
      }
    | {
        type: 'topic';
        topicIconUrl: string;
        skipCoreLoop?: undefined;
      }
    | {
        type?: undefined;
        topicIconUrl?: undefined;
        skipCoreLoop?: undefined;
      }
  ) & {
    withLegacyIndents?: boolean;
  }
>;

export const FAQList: FAQListComponent = ({
  withLegacyIndents,
  type,
  skipCoreLoop,
  topicIconUrl,
  ...rest
}) => {
  const intl = useIntl();
  const title = intl.formatMessage(msgs.title);

  return (
    <S.FAQListContainer $withLegacyIndents={withLegacyIndents} {...rest}>
      <S.Title>{title}</S.Title>
      {type === 'topic' ? (
        <FAQTopicList topicIconUrl={topicIconUrl} />
      ) : (
        <FAQLanguageList skipCoreLoop={skipCoreLoop} />
      )}
    </S.FAQListContainer>
  );
};
